import request from "@/utils/request"
import ucenter_request from "@/utils/ucenter_request"

// 手机号查询
export function getResumeldByPhoneApi(params){
  return ucenter_request({
      url:"/resume/resume/getResumeIdByPhone",
      method:"GET",
      params
  })
}

// 获取民族
export function getNationApi(params){
    return ucenter_request({
        url:"/resume/resume/getNation",
        method:"GET",
        params
    })
}

// 获取学历
export function getEducationApi(params){
    return ucenter_request({
        url:"/resume/resume/getEducation",
        method:"GET",
        params
    })
}

// 添加修改简历信息
export function resumeinfoAPi(params){
    return ucenter_request({
        url:"/resume/resume/editResume",
        method:"GET",
        params
    })
}

// 获取职位
export function getPositionApi(params){
    return ucenter_request({
        url:"/resume/resume/getPosition",
        method:"GET",
        params
    })
}

// 获取薪资范围
export function getSalaryApi(params){
    return ucenter_request({
        url:"/resume/resume/getSalary",
        method:"GET",
        params
    })
}

// 获取教育途径
export function getWayApi(params){
    return ucenter_request({
        url:"/resume/resume/getWay",
        method:"GET",
        params
    })
}

// 模糊查询专业
export function getMajorApi(params){
    return ucenter_request({
        url:"/resume/resume/getMajor",
        method:"GET",
        params
    })
}

// 获取简历信息
export function getResumeApi(params){
    return ucenter_request({
        url:"/resume/resume/getResumeById",
        method:"GET",
        params
    })
}

// 添加修改简历信息
export function editApplyJobApi(params){
    return ucenter_request({
        url:"/resume/resume/editApplyJob",
        method:"GET",
        params
    })
}

//  获取简历信息
export function getApplyJobByResumeIdApi(params){
    return ucenter_request({
        url:"/resume/resume/getApplyJobByResumeId",
        method:"GET",
        params
    })
}

// 添加修改学历
export function editEduExpApi(params){
    return ucenter_request({
        url:"/resume/resume/editEduExp",
        method:"GET",
        params
    })
}

// 获取学历列表
export function getEduExperienceListApi(params){
    return ucenter_request({
        url:"/resume/resume/getEduExperienceList",
        method:"GET",
        params
    })
}

// 添加修改工作经历
export function editWorkExpApi(params){
    return ucenter_request({
        url:"/resume/resume/editWorkExp",
        method:"GET",
        params
    })
}

// 获取工作列表
export function getWorkListApi(params){
    return ucenter_request({
        url:"/resume/resume/getWorkExperienceList",
        method:"GET",
        params
    })
}

// 添加修改项目经验
export function editProjectApi(params){
    return ucenter_request({
        url:"/resume/resume/editProjectExp",
        method:"GET",
        params
    })
}

// 获取项目经验列表
export function getProjectListApi(params){
    return ucenter_request({
        url:"/resume/resume/getProjectExperienceList",
        method:"GET",
        params
    })
}

// 获取简历详情
export function getResumeInfoApi(params){
    return ucenter_request({
        url:"/resume/resume/getResumeInfo",
        method:"GET",
        params
    })
}

// 模糊查询推荐人
export function getReferrerApi(params){
    return ucenter_request({
        url:"/resume/resume/searchByName",
        method:"GET",
        params
    })
}

// 面试结果
export function doAuditionResultApi(params){
    return ucenter_request({
        url:"/resume/resume/doAuditionResult",
        method:"GET",
        params
    })
}

// 转发
export function toRelayApi(params){
    return ucenter_request({
        url:"/resume/resume/relay",
        method:"GET",
        params
    })
}

// 获取面试评价
export function getAuditionResultList(params){
    return ucenter_request({
        url:"/resume/resume/getAuditionResultList",
        method:"GET",
        params
    })
}

// 点击确认发送邮件
export function sendEmailApi(params){
    return ucenter_request({
        url:"/resume/resume/sendEmail",
        method:"GET",
        params
    })
}

// 获取登录人信息
export function getUserApi(params){
    return ucenter_request({
      url:"/personal/myinfo/myzhulong",
      method:"GET",
      params
    })
}

// 教育经历详情
export function getEduExpById(params){
    return ucenter_request({
      url:"/resume/resume/getEduExpById",
      method:"GET",
      params
    })
}

// 工作经历详情
export function getWorkExpById(params){
    return ucenter_request({
      url:"/resume/resume/getWorkExpById",
      method:"GET",
      params
    })
}

// 项目经历详情
export function getProjectExpById(params){
    return ucenter_request({
      url:"/resume/resume/getProjectExpById",
      method:"GET",
      params
    })
}

// 霍兰德首页
export function homeStart(params) {
    return ucenter_request({
        url: '/holland/Index/index',
        method: 'get',
        params
    })
}

// 霍兰德做题页面
export function start(params) {
    return ucenter_request({
        url: '/holland/Index/start',
        method: 'get',
        params
    })
}

// 霍兰德提交结果
export function submitAnswer(params) {
    return ucenter_request({
        url: '/holland/index/submitAnswer',
        method: 'get',
        params
    })
}

// 霍兰德结果页面
export function report(params) {
    return ucenter_request({
        url: '/holland/Index/report',
        method: 'get',
        params
    })
}

// 霍兰德测试结果
export function getHldApi (params) {
    return ucenter_request({
        url: "/resume/resume/getReport",
        method: "GET",
        params
    })
}